module.exports = __webpack_public_path__ + "static/img/アセット 5@2x.9b30f05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 5@2x.png
// module id = YfQI
// module chunks = 1